import { useMutation } from '@tanstack/react-query';

import { login, type PostLoginReq, type PostLoginRes } from './index';

export const useLogin = () =>
	useMutation<PostLoginRes, any, PostLoginReq>({
		mutationFn: login.postLogin,
	});
